export const formatTime = (time, timeFormat12hrs = false) => {


    if (!time) {
        console.log("Time parameter is required");

        return;
    }

    
    const [hours, minutes, seconds = "00"] = time.split(":").map(Number);

    if (timeFormat12hrs) {
        const period = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12;
        return `${formattedHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${period}`;
    } else {
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }
};